import { WebP } from '/src/components/WebP';
import { Button } from '@crazyegginc/hatch';

import { useMetric, usePermissions, useAuthContext } from '/src/hooks';
import { Modal } from '/src/contexts/modal';

import { FEATURES, MANAGE_SUBSCRIPTION_PATH } from '/src/features/_global/constants';

import UpsellErrorsPNG from '@crazyegginc/hatch/dist/images/illustration-upsell-errors.png';
import UpsellErrorsWebP from '@crazyegginc/hatch/dist/images/illustration-upsell-errors.webp';

import { ReactComponent as UpsellIcon } from '@crazyegginc/hatch/dist/images/icon-crown-filled.svg';
import { AppLink } from '/src/features/_global/components/AppLink';

export function ErrorsUpsellModal() {
  const trackMetric = useMetric();
  const { currentAccount, isSharing } = useAuthContext();

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;

  return (
    <Modal dialogClassName="!w-[640px] !p-0 overflow-hidden">
      <div className="p-10 bg-zumthor-500 !pb-0">
        <div className="w-full">
          <WebP webp={UpsellErrorsWebP} fallback={UpsellErrorsPNG} width="558" alt={'errors tracking'} />
        </div>
      </div>
      <div className="w-full border-t border-t-mystic-500 p-[30px]">
        <h4 className="flex items-center text-xl font-semibold text-black-pearl-500 mb-2">
          <UpsellIcon
            className="text-[#fbbd33] mr-3 h-5 w-5 fill-current icon-upsell mb-0.5"
            aria-label={`upsell errors tracking`}
          />{' '}
          {canManageBilling ? 'Upgrade to See JavaScript Errors' : 'Request an upgrade to the Plus plan'}
        </h4>
        <div className="text-sm text-black-pearl-500 leading-tight">
          {canManageBilling ? (
            <>
              <p className="mb-2">
                Silent errors hurt performance, confuse visitors, and reduce conversions. Get instant visibility so you
                can fix issues before they impact your site.
              </p>
              <p>Error Tracking is available on the Plus Plan and above.</p>
            </>
          ) : (
            <>
              <p className="mb-2">Know if site errors are costing you conversions.</p>
              <p>
                Contact your Account Admin{' '}
                {!isSharing && (
                  <>
                    at <span className="font-bold">{currentAccount?.ownerEmail}</span>
                  </>
                )}{' '}
                to upgrade and access Error Tracking.
              </p>
            </>
          )}
        </div>

        {!canManageBilling ? (
          !isSharing ? (
            <Button className="h-[36px] w-[182px] mt-6" component="a" href={`mailto:${currentAccount.ownerEmail}`}>
              Contact Account Owner
            </Button>
          ) : null
        ) : (
          <Button
            className="self-start h-[36px] w-[119px] mt-6"
            component={AppLink}
            to={MANAGE_SUBSCRIPTION_PATH}
            onMouseDown={() => trackMetric('upgrade_cta_click', 'errors_upsell_modal')}
            target={'_blank'}
            rel={'noopener noreferrer'}
          >
            Upgrade Now
          </Button>
        )}
      </div>
    </Modal>
  );
}
